import React, { Component } from "react";
import moment from "moment";
import Highlighter from "react-highlight-words";
import I18n from "../../i18n/I18n";
import { Icon } from "../common";
import Helper from "../../helper/Helper";
import styles from "./PaymentList.scss";
import PaymentListMobile from "./PaymentListMobile";

class PaymentList extends Component {
  PaymentNav(statementNr) {
    this.props.history.push(`/${Helper.getLocale()}/statements/${statementNr}`);
  }

  render() {
    const { data, searchString, paymentsData } = this.props;

    const { statements, payments, starting_balance } = paymentsData;

    let newData = payments && statements ? payments.concat(statements) : [];

    let sortedData = newData.sort(function(a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      const diff = new Date(b.date) - new Date(a.date);
      if (diff === 0 && b.id_partner_payment && !a.id_partner_payment) {
        return 1;
      } else if (diff === 0 && a.id_partner_payment) {
        return -1;
      } else {
        return diff;
      }
    });

    let netDue = starting_balance && starting_balance.starting_balance;

    for (let a = sortedData.length - 1; a >= 0; a--) {
      if (sortedData[a].amount_credit) {
        netDue = netDue - sortedData[a].amount_credit;
      } else if (sortedData[a].amount_debit) {
        netDue = netDue + sortedData[a].amount_debit;
      }
      sortedData[a].netDue = netDue;
    }

    const paymentList = sortedData
      ? sortedData.map((payment, index) => {
          const currencyCode = payment.currency;
          return (
            <tr
              className={
                payment.id_partner_payment ? styles.noClick : styles.row
              }
              onClick={
                payment.id_partner_payment
                  ? () => {}
                  : () => {
                      this.PaymentNav(payment.refNo);
                    }
              }
              key={index}
            >
              <td>
                {payment.id_partner_payment ? (
                  <div className={styles.transaction}>
                    <Icon name="coins" />
                    {I18n.getText("statement.payment")}
                  </div>
                ) : (
                  <div className={styles.transaction}>
                    <Icon name="notepad" />
                    {I18n.getText("statement.statement")}
                  </div>
                )}
              </td>
              <td>{moment(payment.date).format("YYYY-MM-DD")}</td>
              <td>
                <div>
                  <Highlighter
                    highlightClassName={styles.highlight}
                    searchWords={[searchString]}
                    autoEscape={true}
                    textToHighlight={payment.refNo}
                  />
                  {typeof payment.itemCount !== "undefined" ? (
                    <div className={styles.itemCount}>
                      <span className={styles.label}>
                        {I18n.getText("statement.total-items")} :{" "}
                      </span>
                      {payment.itemCount}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </td>
              {false && (
                <td>
                  {typeof payment.total_credit !== "undefined" ? (
                    <span className={styles.positive}>
                      {"+"}&nbsp;
                      {I18n.formatCurrency(
                        Helper.formatPrice(payment.total_credit, currencyCode)
                      )}
                    </span>
                  ) : (
                    "-"
                  )}
                </td>
              )}
              <td>
                {typeof payment.amount_debit !== "undefined" &&
                payment.amount_debit >= 0 ? (
                  <span className={styles.positive}>
                    {I18n.formatCurrency(
                      Helper.formatPrice(payment.amount_debit, currencyCode)
                    )}
                  </span>
                ) : (
                  "-"
                )}
              </td>
              <td>
                {typeof payment.amount_credit !== "undefined" ||
                (typeof payment.amount_debit !== "undefined" &&
                  payment.amount_debit < 0) ? (
                  <span className={styles.negative}>
                    {I18n.formatCurrency(
                      Helper.formatPrice(
                        payment.amount_credit || payment.amount_debit,
                        currencyCode
                      )
                    )}
                  </span>
                ) : (
                  "-"
                )}
              </td>
              {false && (
                <td>
                  {typeof payment.total_debit !== "undefined" ? (
                    <span className={styles.negative}>
                      {I18n.formatCurrency(
                        Helper.formatPrice(payment.total_debit, currencyCode)
                      )}
                    </span>
                  ) : (
                    "-"
                  )}
                </td>
              )}
              <td>
                <span
                  className={
                    payment.netDue < 0 ? styles.negative : styles.positive
                  }
                >
                  {I18n.formatCurrency(
                    Helper.formatPrice(payment.netDue, currencyCode)
                  )}
                </span>
              </td>
            </tr>
          );
        })
      : "";

    // paymentList for small screens
    const paymentListMobile = (
      <div>
        <PaymentListMobile
          data={sortedData}
          currencyCode={this.props.currencyCode}
          history={this.props.history}
          lang={this.props.lang}
          browser={this.props.browser}
          paymentNav={this.PaymentNav}
        />
      </div>
    );

    return (
      <div className={styles.ctr}>
        {paymentsData && paymentsData.aggregates ? (
          <div className={styles.summaryCtr}>
            <div className={styles.summaryItem}>
              <h6 className={styles.summaryTitle}>
                {I18n.getText(
                  "dashboard.revenue-summary",
                  {
                    currency: I18n.formatCurrency({
                      currency: this.props.currencyCode
                    })
                  },
                  "Total Paid Revenue ({currency})"
                )}
              </h6>
              <div className={styles.summaryContent}>
                {I18n.formatCurrency(
                  Helper.formatPrice(
                    paymentsData.aggregates.total_paid,
                    this.props.currencyCode
                  )
                )}
              </div>
            </div>
            <div className={styles.summaryItem}>
              <h6 className={styles.summaryTitle}>
                {I18n.getText("dashboard.unpaid-revenue", {
                  currency: I18n.formatCurrency({
                    currency: this.props.currencyCode
                  })
                })}
              </h6>
              <div className={styles.summaryContent}>
                {I18n.formatCurrency(
                  Helper.formatPrice(
                    paymentsData.aggregates.total_unpaid,
                    this.props.currencyCode
                  )
                )}
              </div>
            </div>
            <div className={styles.summaryItem}>
              <h6 className={styles.summaryTitle}>
                {I18n.getText("statement.next-payment")}
              </h6>
              <div className={styles.summaryContent}>
                {moment(paymentsData.next_payment).format("YYYY-MM-DD")}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {this.props.browser && this.props.browser.greaterThan.tablet ? (
          <table className={styles.table}>
            <thead>
              <tr className={`${styles.row} ${styles.head}`}>
                <th>{I18n.getText("statement.transaction")}</th>
                <th>{I18n.getText("credit.date")}</th>
                <th>{I18n.getText("statement.ref-no", {}, "Ref No")}</th>
                {false && <th>{I18n.getText("order-details.sub-total")}</th>}
                <th>{I18n.getText("statements.debit")}</th>
                <th>{I18n.getText("statements.credit")}</th>
                {false && (
                  <th>{I18n.getHtml("statement-details.deductions")}</th>
                )}
                <th>{I18n.getText("sales.net-due")}</th>
              </tr>
            </thead>
            <tbody>{paymentList}</tbody>
          </table>
        ) : (
          paymentListMobile
        )}
      </div>
    );
  }
}

export default PaymentList;



// WEBPACK FOOTER //
// ./src/components/statement/PaymentList.js